import React, { useState, useEffect, useRef } from 'react'
import { DatePicker, Space } from 'antd';
import CalenderCard from './CalenderCard';
import WeeklyData from './WeeklyData';
import cubejs from "@cubejs-client/core";
import { handleQueryMyOnboardCount, handleQueryMyCaseCount, handleQueryMyOverallCaseCount,handleMyIncentiveAmount } from './utils';
import dayjs from 'dayjs'
import MonthlyData from './MonthlyData';
const { RangePicker } = DatePicker;

const days = {
    'Monday': 'Mon',
    'Tuesday': 'Tue',
    'Wednesday': 'Wed',
    'Thursday': 'Thu',
    'Friday': 'Fri',
    'Saturday': 'Sat',
    'Sunday': 'Sun'
}

function TeamContribution({ accessLevel, radioValue,modality,teamName }) {
    const [data, setData] = useState([
        // { "count": 20, "date": "2024-04-01", "day": "Mon" },
        // { "count": 20, "date": "2024-04-02", "day": "Tue" },
        // { "count": 20, "date": "2024-04-03", "day": "Wed" },
        // { "count": 20, "date": "2024-04-04", "day": "Thu" },
        // { "count": 20, "date": "2024-04-05", "day": "Fri" },
        // { "count": 20, "date": "2024-04-06", "day": "Sat" },
        // { "count": 20, "date": "2024-04-07", "day": "Sun" },
        // { "count": 20, "date": "2024-04-08", "day": "Mon" },
        // { "count": 20, "date": "2024-04-09", "day": "Tue" },
        // { "count": 20, "date": "2024-04-10", "day": "Wed" },
        // { "count": 20, "date": "2024-04-11", "day": "Thu" },
        // { "count": 20, "date": "2024-04-12", "day": "Fri" },
        // { "count": 20, "date": "2024-04-13", "day": "Sat" },
        // { "count": 20, "date": "2024-04-14", "day": "Sun" },
        // { "count": 20, "date": "2024-04-15", "day": "Mon" },
        // { "count": 20, "date": "2024-04-16", "day": "Tue" },
        // { "count": 20, "date": "2024-04-17", "day": "Wed" },
        // { "count": 20, "date": "2024-04-18", "day": "Thu" },
        // { "count": 20, "date": "2024-04-19", "day": "Fri" },
        // { "count": 20, "date": "2024-04-20", "day": "Sat" },
        // { "count": 20, "date": "2024-04-21", "day": "Sun" },
        // { "count": 20, "date": "2024-04-22", "day": "Mon" },
        // { "count": 20, "date": "2024-04-23", "day": "Tue" },
        // { "count": 20, "date": "2024-04-24", "day": "Wed" },
        // { "count": 20, "date": "2024-04-25", "day": "Thu" },
        // { "count": 20, "date": "2024-04-26", "day": "Fri" },
        // { "count": 20, "date": "2024-04-27", "day": "Sat" },
        // { "count": 20, "date": "2024-04-28", "day": "Sun" },
        // { "count": 20, "date": "2024-04-29", "day": "Mon" }
    ]
    )
    const [contributionCase, setContributionCase] = useState([])
    const [overallCaseCount, setOverallCaseCount] = useState([])
    const [incentiveAmount, setIncentiveAmount] = useState([])
    const [selectedRangeOnboard, setSelectedRangeOnboard] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);

    const [incentiveDate, setIncentiveDate] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);
    const [selectedRangeCase, setSelectedRangeCase] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);

    const [overallCaseDate, setOverallCaseDate] = useState([dayjs(new Date('2024-04-01')), dayjs(new Date())]);


    



    const handleRangeChange = (value) => {
        setSelectedRangeOnboard(value);
    };


    const handleRangeChangeCase = (value) => {
        setSelectedRangeCase(value);
    };

    const handleOverallChangeCase = (value) => {
        setOverallCaseDate(value);
    };


    const handleIncentiveDateChange= (value) => {
        setIncentiveDate(value);
    };



    const dateFormat = (date) => {
        const dateObject = new Date(date);
        // Extract the year, month, and day from the date object
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        // Construct the output date string in the format "yyyy-mm-dd"
        const outputDateString = `${year}-${month}-${day}`;
        return outputDateString
    }

    const getPreiviousDate = (date) => {
        const currentDate = new Date(date);

        // Get the previous date by subtracting one day from the current date
        const previousDate = new Date(currentDate);
        previousDate?.setDate(previousDate?.getDate() - 1);

        // Extract the year, month, and day from the previous date
        const year = previousDate.getFullYear();
        const month = (previousDate.getMonth() + 1).toString().padStart(2, '0');
        const day = previousDate.getDate().toString().padStart(2, '0');

        // Construct the output date string in the format "yyyy-mm-dd"
        const previousDateString = `${year}-${month}-${day}`;
        return previousDateString
    }

    const getDayName = (dayIndex) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[dayIndex];
    };

    const fillMissingDatesWithZeroCount = (data, selectedDate) => {
        const filledData = [];
        const startDate = new Date(dateFormat(selectedDate?.[0]?.$d));
        const endDate = new Date(dateFormat(selectedDate?.[1]?.$d));
        let currentIndex = 0;

        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const dateString = currentDate.toISOString()?.split('T')[0];
            const existingEntry = data.find(item => item.date === dateString);

            if (existingEntry) {
                filledData.push(existingEntry);
            } else {
                filledData.push({ count: 0, date: dateString, day: getDayName(currentDate.getDay()) });
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }
        //console.log(filledData)
        // setFilledDates(filledData)
        return filledData;
    };

    const handleOnboardCount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(selectedRangeOnboard?.[0]?.$d))
        const endDate = dateFormat(selectedRangeOnboard?.[1]?.$d)
        setData([])
        try {
            await cubejsApi
                .load(handleQueryMyOnboardCount(accessLevel?.name, startDate, endDate, 'team',modality,teamName))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Onboarded_date']?.split('T')[0],
                            day: days[data['Contribution.onboarded_day_name']],
                            count: data['Contribution.client_count']
                        }
                    })
                    //console.log(modifiedData)
                    setData(fillMissingDatesWithZeroCount(modifiedData, selectedRangeOnboard))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }


    const handleCaseCount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(selectedRangeCase?.[0]?.$d))
        const endDate = dateFormat(selectedRangeCase?.[1]?.$d)
        setContributionCase([])
        try {
            await cubejsApi
                .load(handleQueryMyCaseCount(accessLevel?.name, startDate, endDate, 'team',modality,teamName))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Date']?.split('T')[0],
                            day: days[data['Contribution.day_name']],
                            count: data['Contribution.total_case_count']
                        }
                    })
                    //console.log(modifiedData)
                    setContributionCase(fillMissingDatesWithZeroCount(modifiedData, selectedRangeCase))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    // useEffect(()=>{
    //     const chatContainer = document.querySelectorAll(".monthly-stats");
    //     if (chatContainer?.length > 0) {
    //         for (let i = 0; i < chatContainer.length; i++) {
    //             console.log(i)
    //             chatContainer[i].scrollLeft = chatContainer[i].scrollWidth;
    //         }
    //     }
    
    // },[overallCaseCount,data,incentiveAmount,contributionCase,radioValue])


    const handleOverallCase = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(overallCaseDate?.[0]?.$d))
        const endDate = dateFormat(overallCaseDate?.[1]?.$d)
        setOverallCaseCount([])
        try {
            await cubejsApi
                .load(handleQueryMyOverallCaseCount(accessLevel?.name, startDate, endDate, 'team',modality))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Date']?.split('T')[0],
                            day: days[data['Contribution.day_name']],
                            count: data['Contribution.total_case_count']
                        }
                    })
                    //console.log(modifiedData)
                    setOverallCaseCount(fillMissingDatesWithZeroCount(modifiedData, overallCaseDate))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const handleIncentiveAmount = async (cubejsApi) => {
        // //console.log(selectedRangeOnboard[0]?.$d)
        const startDate = getPreiviousDate(dateFormat(incentiveDate?.[0]?.$d))
        const endDate = dateFormat(incentiveDate?.[1]?.$d)
        setIncentiveAmount([])
        try {
            await cubejsApi
                .load(handleMyIncentiveAmount(accessLevel?.name, startDate, endDate, 'team',modality,teamName))
                .then((resultSet) => {
                    //    //console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            date: data['Contribution.Date']?.split('T')[0],
                            day: days[data['Contribution.day_name']],
                            count: data['Contribution.incentive_amount']
                        }
                    })
                    //console.log(modifiedData)
                    setIncentiveAmount(fillMissingDatesWithZeroCount(modifiedData, incentiveDate))
                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const seperateMonthData = (separate) => {
        const separatedData = {};
    
        separate.forEach(item => {
            const yearMonth = item.date.slice(0, 7); // Extract "YYYY-MM" from the date string
            if (!separatedData[yearMonth]) {
                separatedData[yearMonth] = []; // Initialize the array if it doesn't exist
            }
            separatedData[yearMonth].push({ ...item, yearMonth: yearMonth }); // Add yearMonth info to each item
        });
    
        // Convert separated data to an array of objects, sorted by year and month
        const result = Object.keys(separatedData)
            .sort((a, b) => new Date(b) - new Date(a)) // Sort based on year and month
            .map(yearMonth => ({
                yearMonth: yearMonth, 
                data: separatedData[yearMonth]
            }));
    
        console.log(result);
        return result;
    };


    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && selectedRangeOnboard?.[0] && selectedRangeOnboard?.[1] &&modality) {
            handleOnboardCount(cubejsApi)
        }
    }, [accessLevel, selectedRangeOnboard,modality,teamName])

    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && selectedRangeCase?.[0] && selectedRangeCase?.[1] && modality) {
            handleCaseCount(cubejsApi)
        }
    }, [accessLevel, selectedRangeCase,modality,teamName])

    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && overallCaseDate?.[0] && overallCaseDate?.[1] && modality) {
            handleOverallCase(cubejsApi)
        }
    }, [accessLevel, overallCaseDate,modality])

    useEffect(() => {
        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel && incentiveDate?.[0] && incentiveDate?.[1] && modality) {
            handleIncentiveAmount(cubejsApi)
        }
    }, [accessLevel, incentiveDate,modality,teamName])

    return (
        <div className='contribution-first-table' >

            <div className='contribution-first-table-first' >
                <div className='date-ranger'>
                    <div > Onboard Count</div>
                    <div>
                        <RangePicker value={selectedRangeOnboard}
                            onChange={handleRangeChange}
                             />
                    </div>
                </div>
                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData radioValue={radioValue} data={data} selectedRangeOnboard={selectedRangeOnboard} dateFormat={dateFormat} />
                    }

{radioValue === 'monthly' && <div   className='monthly-stats'>
                        {seperateMonthData(data)?.map((data1, id) => (

                            <MonthlyData key={id} data={data1?.data} selectedRangeOnboard={selectedRangeOnboard} dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }
                    
                </div>
            </div>

            <div>
                <div className='date-ranger'>
                    <div> Case Count</div>
                    <div>
                        <RangePicker value={selectedRangeCase}
                            onChange={handleRangeChangeCase}  />
                    </div>
                </div>


                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData radioValue={radioValue} data={contributionCase} selectedRangeOnboard={selectedRangeCase} dateFormat={dateFormat} />
                    }

{radioValue === 'monthly' && <div  className='monthly-stats'>
                        {seperateMonthData(contributionCase)?.map((data1, id) => (

                            <MonthlyData key={id} data={data1?.data} selectedRangeOnboard={selectedRangeCase} dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }
                </div>


            </div>

            <div>
                <div className='date-ranger'>
                    <div> Incentive Amount</div>
                    <div>
                        <RangePicker value={incentiveDate}
                            onChange={handleIncentiveDateChange}  />
                    </div>
                </div>

                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData radioValue={radioValue} data={incentiveAmount} selectedRangeOnboard={incentiveDate} amount={'amount'}  dateFormat={dateFormat} />
                    }

{radioValue === 'monthly' && <div className='monthly-stats'>
                        {seperateMonthData(incentiveAmount)?.map((data1, id) => (

                            <MonthlyData key={id} data={data1?.data} selectedRangeOnboard={incentiveDate} amount={'amount'}  dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }

                </div>


            </div>

            <div>
                <div className='date-ranger'>
                    <div> Overall Cases Count</div>
                    <div>
                        <RangePicker value={overallCaseDate}
                            onChange={handleOverallChangeCase}  />
                    </div>
                </div>

                <div>

                    <div>
                        <div>Weekly</div>
                        <div>Mon</div>
                        <div>Tues</div>
                        <div>Wed</div>
                        <div>Thur</div>
                        <div>Fri</div>
                        <div>Sat</div>
                        <div>Sun</div>
                        <div>Total</div>
                        {radioValue === 'monthly' && <div>Month Total</div> }
                    </div>
                    {radioValue === 'weekly' &&
                        <WeeklyData radioValue={radioValue} data={overallCaseCount} selectedRangeOnboard={overallCaseDate} dateFormat={dateFormat} />
                    }

{radioValue === 'monthly' && <div   className='monthly-stats'>
                        {seperateMonthData(overallCaseCount)?.map((data1, id) => (

                            <MonthlyData key={id} data={data1?.data} selectedRangeOnboard={overallCaseDate} dateFormat={dateFormat} />

                        ))
                        }
                    </div>
                    }

                </div>


            </div>

        </div>
    )
}

export default TeamContribution
